// extracted by mini-css-extract-plugin
export default {"wrapper":"collapsible-list-section-module--wrapper--m-paP","show":"collapsible-list-section-module--show--RU0wr","hide":"collapsible-list-section-module--hide--ugScS"};